<template>
  <div class="section">
    <b-field v-if="!maxEmailsReached" expanded>
      <b-input
        v-model="newEmail"
        placeholder="email"
        type="text"
        icon="email"
        expanded
      ></b-input>
      <p class="control">
        <b-button @click="addEmail" type="is-primary" icon-right="plus" />
      </p>
    </b-field>
    <b-field v-for="(email, index) in value" :key="email" class="" expanded>
      <b-input
        :value="email"
        icon="email"
        placeholder="email"
        expanded
      ></b-input>
      <p class="control">
        <b-button
          @click="deleteEmail(index)"
          type="is-danger"
          icon-pack="fas"
          icon="trash"
          icon-right="trash"
        />
      </p>
    </b-field>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: Array,
    maxEmails: {
      type: Number,
      default: 4
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newEmail: null
    }
  },
  watch: {
    value: function(val) {
      this.$emit('input', val)
    }
  },
  computed: {
    maxEmailsReached: function() {
      return this.value.length >= this.maxEmails
    }
  },
  methods: {
    deleteEmail: function(email) {
      this.$delete(this.value, email)
    },
    addEmail: function() {
      this.value.push(this.newEmail)
      this.newEmail = null
    }
  }
}
</script>

<style lang="scss" scoped>
.field.is-grouped .field:not(:last-child),
.control {
  margin-right: 0 !important;
}
.field.is-grouped .field,
.control {
  margin-right: 5px !important;
}
</style>
